module.exports = __webpack_public_path__ + "img/review-icon.0731592c.svg";